import styled from 'styled-components';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const UnlockIconSVG = styled(CloudImage)`
  width: 80px;
  margin-left: -12px;
`;

export const ControlContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const MainTextPairing = styled(TextPairing)`
  margin-top: ${themeSpace(10)};
  .text-pairing-eyebrow {
    max-width: 380px;
  }
  .text-pairing-body {
    max-width: 653px;
  }
  .text-pairing-title {
    max-width: 520px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 375px;
    }
    .text-pairing-body {
      max-width: 290px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-eyebrow {
      max-width: 420px;
    }
  }
`;
